module.exports = __webpack_public_path__ + "img/MEDIA005.15292c6f.jpg";